
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProjectTemplate',
  props: {
    projectName: String,
    image: String,
    id: String,
    isSearched: {
      default: false,
      required: false,
      type: Boolean
    }
  },
  methods: {
    selectTemplate() {
      if (this.id)
        this.$router.push(`projectManager/newWorkspace?templateId=${this.id}`);
    }
  }
});
